// extracted by mini-css-extract-plugin
export default {"root":"styles_root__JEKWj","input_field":"styles_input_field__0SGBC","size_slider":"styles_size_slider__Ms-KR"};